function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { StyleSheet } from 'react-native';
import { Text, View } from "../../native";
import * as R from 'unitx/ramda';
import { useFormContext } from "./FormContext";

const ErrorList = ({
  errors,
  formContext
}) => {
  const {
    mapping,
    showErrorList
  } = useFormContext(formContext);
  return showErrorList ? /*#__PURE__*/React.createElement(View, _extends({}, mapping.fieldContainer, {
    style: [mapping.fieldContainer.style, styles.container]
  }), /*#__PURE__*/React.createElement(Text, _extends({}, mapping.errorTitle, {
    style: [mapping.errorTitle.style]
  }), "Errors"), R.mapIndexed((error, i) => /*#__PURE__*/React.createElement(Text, _extends({
    key: i
  }, mapping.errorText, {
    style: [mapping.errorText.style]
  }), error.stack))(errors)) : null;
};

const styles = StyleSheet.create({
  container: {
    padding: 10,
    borderRadius: 10,
    marginBottom: 20
  },
  title: {
    marginBottom: 10
  }
});
export default ErrorList;